import { e } from "./engine-user-agent.js";
var i = /(?:ipad|iphone|ipod).*applewebkit/i.test(e);
export { i as e };